module.exports = __webpack_public_path__ + "static/media/bullseye-pointer.7bc40d72.svg";